import { Text, Grid, GridItem, Icon, HStack, Link } from "@chakra-ui/react";
import { FaAlignLeft, FaExternalLinkAlt } from "react-icons/fa";
import {
  PersonDestination,
  ProductPersonType,
} from "../../../../common/types/person";
import { DESTINATION_TYPES } from "../../../../common/types/unifiedMapping";
import { EditableFieldByType } from "../../../../components/EditableFieldByType";
import { DESTINATION_TYPE_SPECIFIC_ICONS } from "../../../../common/constants/unifiedMapping";
import { isBlank } from "../../../../common/helper/commonHelper";
import { isObject } from "lodash";
export default function DisplayGrid({
  entries,
  editDetails,
  enableEdit,
}: {
  entries: ProductPersonType[];
  editDetails?: (key: string, value: string) => void;
  enableEdit?: boolean;
}) {
  function onChangeHandler(key: string, value: any) {
    editDetails && editDetails(key, value);
  }

  function formatValue(details: PersonDestination) {
    if (isBlank(details.value)) {
      return "(empty)";
    }
    if (
      (details.type === DESTINATION_TYPES.BOOLEAN ||
        [true, false].includes(details.value)) &&
      details.value !== null
    ) {
      return details.value ? "True" : "False";
    }
    if (details.type === DESTINATION_TYPES.DATETIME && details.value !== null) {
      return new Date(details.value).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    }
    if (
      (details.type === DESTINATION_TYPES.JSON || isObject(details.value)) &&
      details.value !== null
    ) {
      return JSON.stringify(details.value);
    }
    return `${details.value}`;
  }

  return (
    <Grid templateColumns={`repeat(2, 1fr)`} my={2} gridColumnGap={8}>
      {entries &&
        entries.map(
          ({ details, key, onDataClick, isHyperLink, redirectPage }) => {
            const isValueEmpty = isBlank(details.value);
            const formattedDetails = formatValue(details);
            return (
              <GridItem key={key} colSpan={1}>
                <Grid
                  templateColumns={`repeat(5, 1fr)`}
                  my={3}
                  alignItems="center"
                >
                  <GridItem colSpan={2}>
                    <HStack
                      justifyContent="flex-start"
                      color={"blackAlpha.600"}
                    >
                      <Icon
                        fontSize="14"
                        as={
                          DESTINATION_TYPE_SPECIFIC_ICONS[details.type] ??
                          FaAlignLeft
                        }
                      />
                      <Text fontWeight="500" textTransform="capitalize">
                        {details.display ?? key}
                      </Text>
                    </HStack>
                  </GridItem>
                  <GridItem colSpan={3}>
                    {enableEdit && (!details.read_only || details.updatable) ? (
                      <EditableFieldByType
                        type={details.type}
                        value={details.value}
                        maxlength={details.length ?? undefined}
                        onChange={(value: any) => onChangeHandler(key, value)}
                      />
                    ) : isHyperLink ? (
                      <HStack pl="4">
                        <Link onClick={redirectPage} color="blue.600">
                          {formattedDetails}
                          <Icon fontSize="19px" pt="1px" pl="6px">
                            <FaExternalLinkAlt />
                          </Icon>
                        </Link>
                      </HStack>
                    ) : (
                      <Text
                        fontWeight="500"
                        wordBreak="break-all"
                        ml={4}
                        color={isValueEmpty ? "gray.500" : "brand.black"}
                        style={
                          !isBlank(details.value) && onDataClick
                            ? { textDecoration: "underline" }
                            : {}
                        }
                        _hover={
                          !isBlank(details.value) && onDataClick
                            ? { color: "blue.400" }
                            : {}
                        }
                        onClick={() =>
                          onDataClick && onDataClick(formattedDetails)
                        }
                      >
                        {formattedDetails}
                      </Text>
                    )}
                  </GridItem>
                </Grid>
              </GridItem>
            );
          }
        )}
    </Grid>
  );
}
